export function selectedButtonVariant(
  value: string | undefined,
  match: string
): string {
  return value === match ? 'solid' : 'outline';
}
